/* 陸遜傳・第 4 章：襄陽（234 年）
 * 沔水（漢水）在南邊由西往東，西邊江岸是諸葛瑾的船。中間是陸遜的營：營前三畦葑豆田、一張棋枰、一處射垛。
 * 東北是襄陽城（方城，南門對著吳營）。 */
export const CAMP = [3700, 2400], DOCK = [1500, 3500], CITY = { x: 7300, y: 1500, hw: 700, hh: 480 };
export const GATE = [CITY.x, CITY.y + CITY.hh], NEAR = [CITY.x - 200, CITY.y + CITY.hh + 650];
export const PLOTS = [[3100, 3050], [3700, 3150], [4300, 3050]], BOARD = [3700, 2850], TARGET = [4550, 2450], RANGE = [4150, 2500];
const T = 34, G = 120, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export default {
  id: 'luxun_xiangyang', name: '襄陽', W: 9000, H: 4800, seed: 234,
  bases: [CAMP, [CITY.x, CITY.y]],
  walls: [[CITY.x, N, CITY.hw + T, T], [(Wx + CITY.x - G) / 2, S, (CITY.x - G - Wx) / 2 + T, T], [(CITY.x + G + E) / 2, S, (E - CITY.x - G) / 2 + T, T], [Wx, CITY.y, T, CITY.hh], [E, CITY.y, T, CITY.hh]],
  rivers: [{ pts: [[-100, 4200], [3000, 4150], [6000, 4230], [9100, 4170]], hw: 330, fords: [] }],
  roads: [
    { pts: [DOCK, [2500, 3000], CAMP, [5600, 2500], [CITY.x, S + 300], GATE, [CITY.x, CITY.y]], w: 140 },
  ],
  rocks: [[1600, 1100, 420, 220], [5200, 1100, 380, 200], [8400, 3200, 360, 200]],
  woods: 0.45,
  sight: 0.8,
  clearings: [[CAMP[0], CAMP[1], 700], [CAMP[0], 3050, 760], [DOCK[0], DOCK[1] - 100, 360], [CITY.x, CITY.y, 820], [NEAR[0], NEAR[1], 500]],
  fields: PLOTS.map(([x, y]) => [x, y, 240, 110]),
  villages: [{ x: CITY.x, y: CITY.y, n: 6, r: 360 }],
  tents: [{ x: CAMP[0], y: CAMP[1] - 260, n: 7, r: 300, chief: true, col: '#b8433a', flag: '陸' }],
};
